// /* global SideDrawer */

// class CartDrawer extends SideDrawer {
//   connectedCallback() {
//     this.bindEvents();
//   }

//   bindEvents() {
//     this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
//     this.closeDrawerViaEventHandler = this.close.bind(this, null);
//     document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
//     document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
//     document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
//     this.addEventListener('on:cart-drawer:before-open', () => {
//       theme.manuallyLoadImages(this);
//       this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
//     });
//     this.addEventListener('on:cart:after-merge', () => {
//       theme.manuallyLoadImages(this);
//       this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
//     });
//   }

//   disconnectedCallback() {
//     document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
//     document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
//     document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
//   }

//   /**
//    * Handle when the drawer is opened via an event
//    * @param {object} evt - Event object.
//    */
//   handleDrawerOpenViaEvent(evt) {
//     this.open(evt.detail ? evt.detail.opener : null);
//   }

//   /**
//    * Trigger refresh of contents
//    */
//   cartRefreshHandler() {
//     this.querySelector('cart-form').refresh();
//   }

//   /**
//    * Update section's cart-form element with new contents
//    * @param {string} html - Whole-section HTML.
//    */
//   updateFromCartChange(html) {
//     this.querySelector('cart-form').refreshFromHtml(html);
//   }
// }

// window.customElements.define('cart-drawer', CartDrawer);


class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler.bind(this));

    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  cartRefreshHandler() {
    const cartForm = this.querySelector('cart-form');
    if (cartForm) cartForm.refresh();
  }

  /**
   * Update section's cart-form element with new contents.
   *
   * IMPORTANT: this always trusts the server-rendered HTML as the source of
   * truth for what's in the cart. It deliberately does NOT try to detect
   * rows that vanished between the old and new HTML and re-insert them as
   * "out of stock" — there's no reliable way here to tell "the customer
   * just removed this line" apart from "this line disappeared for some
   * other reason", and treating a deliberate removal as the latter
   * permanently re-adds the very item the customer just removed. Worse,
   * because that resurrected row stays flagged, it also re-blocks
   * checkout for every OTHER item still in the cart on the next check.
   *
   * Out-of-stock detection and checkout-blocking is handled entirely by
   * <cart-inventory-check>, which re-validates live inventory against the
   * cart at the moment of checkout and flags/messages only the lines that
   * are actually still in the cart. That's the single source of truth for
   * availability — it shouldn't be duplicated (and fought with) here.
   *
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    const cartForm = this.querySelector('cart-form');
    if (!cartForm) return;

    const parser = new DOMParser();
    const newDoc = parser.parseFromString(html, 'text/html');
    const newCartForm = newDoc.querySelector('cart-form');

    if (typeof cartForm.refreshFromHtml === 'function') {
      cartForm.refreshFromHtml(newCartForm ? newCartForm.innerHTML : html);
    } else {
      cartForm.innerHTML = newCartForm ? newCartForm.innerHTML : html;
    }

    theme.manuallyLoadImages(this);
    this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());

    // Cart contents just changed — re-arm the checkout-link bindings and
    // clear any stale out-of-stock message/flags left over from a
    // previous checkout attempt.
    const inventoryCheck = document.querySelector('cart-inventory-check');
    if (inventoryCheck && typeof inventoryCheck.reset === 'function') {
      inventoryCheck.reset();
    }
  }
}

window.customElements.define('cart-drawer', CartDrawer);

